import React from 'react'
import "./Main.css"
import Home from './Home/Home'
const Main = () =>{
  return (
    <div>
        <Home />
    </div>
  )
}
export default Main